<template>
  <div>
    <div class="bag-item-menu-header">
      <div class="bag-item-menu-header-label">{{ item.displayName }}</div>
      <div>{{ item.subTotal | toCurrency() }}</div>
    </div>
    <div>{{ item.servesText }}</div>
    <div v-show="showItems('premiumToppings')" class="bag-item-category-header">
      <br />
      Premium Toppings
    </div>
    <div>{{ selectedSubItems(item, menuItem, 'premiumToppings') }}</div>
    <br />
    <div class="bag-item-btn-group">
      <gold-link class="bag-item-btn" @click="editClose">EDIT</gold-link>
      <gold-link class="bag-item-btn" @click="showRemove">REMOVE</gold-link>
    </div>
  </div>
</template>

<script>
import GoldLink from '@/components/common/GoldLink'
import { commonBuilderMixin } from '@/mixins/commonBuilder'
import { CHIPS_AND_SALSA } from '@/router/routeNames'

export default {
  name: 'bag-item-chips-and-salsa',
  props: ['item'],
  components: { GoldLink },
  mixins: [commonBuilderMixin],
  methods: {
    editClose() {
      this.$root.$emit('close-bag')
      this.editItemFromBag(CHIPS_AND_SALSA)
    },
    showRemove() {
      this.$root.$emit('open-bag-delete', this.item.orderItemId)
    },
    showItems(category) {
      return (
        this.selectedSubItems(this.item, this.menuItem, category).length > 0
      )
    },
  },
  computed: {
    menuItem: {
      get() {
        return this.$store.getters.getMenuItem(this.item.menuId)
      },
    },
  },
}
</script>
